import events from './events'
import store from 'reducers'
import Actions from './Actions'
import {arrayToJSONByID} from 'lib/helpers'
import {SelectedCardActions, SessionActions} from './'
import dayjs from 'dayjs'

export default class CardActions extends Actions{
    static get target(){
        return 'cards'
    }
    static create(options){
        return this.client.cards.create(options).then((response)=>{
            const card = response.data
            this.assign({
                [`${card.id}`]: card
            })
            return SelectedCardActions.set(card)
        })
    }

    static createToken(){
        return nilApiClient.cards.createToken().then((response)=>{
            return new Promise((resolve, reject)=>{
                SessionActions.merge({
                    gravity: {
                        token: response.data,
                        expires: dayjs().add(9, 'minutes').format()
                    }
                })
                
                resolve()

                const current = dayjs().toDate().getTime()
                const future = dayjs().add(9, 'minute').toDate().getTime()
                
                setTimeout(()=>{
                    this.fetchPaymentToken()
                }, future - current)
            })
        })
    }
    static fromArray(cards){
        let data = {}
        this.appendMany(
            arrayToJSONByID(cards)
        )
    }
}


// WEBPACK FOOTER //
// ./actions/CardActions.js